export default __webpack_public_path__ + "static/media/quiz-banner.3f668ca0.png";